import { Injectable } from '@angular/core'
import {
    ratingColorSet,
    statusColorSet,
    workspaceColorSet,
} from '@app/shared/color-picker/color-sets'
import { SetType } from '@app/shared/models/picker'
import { random } from 'lodash-es'

interface ColorSet {
    [key: string]: string[]
}

@Injectable({
    providedIn: 'root',
})
export class ColorPickerService {
    constructor() {}

    private readonly colorSet: ColorSet = {
        status: statusColorSet,
        rating: ratingColorSet,
        workspace: workspaceColorSet,
    }

    getColorSet(setType: SetType) {
        return this.colorSet[setType]
    }

    getDefaultColor(pickerType: SetType) {
        if (pickerType === SetType.RATING) {
            return '#FF6E40'
        }

        return this.colorSet['workspace'][random(0, this.colorSet['workspace'].length - 1)]
    }
}
